import React, { useState, useEffect, useCallback, useContext } from 'react';
import SideBar from './SideBar'
import ProductCard from '../Common/Product/ProductCard'

import { connect, useSelector } from "react-redux";
import * as actions from "../../actions/service";
import { useHistory } from "react-router-dom"
import * as user from "../../actions/user";
import _ from 'lodash'
import { AuthContext } from '../../context/AuthContext';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import API from '../../utils/api';
import Swal from 'sweetalert2';
import moment from 'moment';
import { useTranslation} from 'react-i18next';

const timeSlots = [
  { name: '9.00 AM', value: '9.00', disabled: false },
  { name: '9.30 AM', value: '9.30', disabled: false },
  { name: '10.00 AM', value: '10.00', disabled: false },
  { name: '10.30 AM', value: '10.30', disabled: false },
  { name: '11.00 AM', value: '11.00', disabled: false },
  { name: '11.30 AM', value: '11.30', disabled: false },
  { name: '12.00 PM', value: '12.00', disabled: false },
  { name: '12.30 PM', value: '12.30', disabled: false },
  { name: '1.00 PM', value: '13.00', disabled: false },
  { name: '1.30 PM', value: '13.30', disabled: false },
  { name: '2.00 PM', value: '14.00', disabled: false },
  { name: '2.30 PM', value: '14.30', disabled: false },
  { name: '3.00 PM', value: '15.00', disabled: false },
  { name: '3.30 PM', value: '15.30', disabled: false },
  { name: '4.00 PM', value: '16.00', disabled: false },
  { name: '4.30 PM', value: '16.30', disabled: false },
  { name: '5.00 PM', value: '17.00', disabled: false },
  { name: '5.30 PM', value: '17.30', disabled: false },
  { name: '6.00 PM', value: '18.00', disabled: false },
  { name: '6.30 PM', value: '18.30', disabled: false },
  { name: '7.00 PM', value: '19.00', disabled: false },
  { name: '7.30 PM', value: '19.30', disabled: false },
  { name: '8.00 PM', value: '20.00', disabled: false },
  { name: '8.30 PM', value: '20.30', disabled: false },
  { name: '9.00 PM', value: '21.00', disabled: false },
  { name: '9.30 PM', value: '21.30', disabled: false }
]
const LeftSideBar = (props) => {
  const { t, i18n } = useTranslation();
    const { logout, getAuthUser, isAuthenticated, getCurrentBranch } = useContext(AuthContext)
    const authUser = getAuthUser()
    const isAuthentic = isAuthenticated()
    const branch =getCurrentBranch()
    const [sort, setSort] = useState('all');
    const history = useHistory()
    const [myCart, setMycart] = useState(props.cartArray);
    const [isLoading, SetIsLoading] = useState(true);
    const [currentCategory, setCurrentCategory] = useState('all');
    const [currentDepartment, setCurrentDepartment] = useState('all');
    const [keywordFilter, setKeywordFilter] = useState('');

    const [slots, setSlots] = useState(timeSlots);
    const [selectedSlot, setSelectedSlot] = useState("");
    const [show, setShow] = useState(false);
    const [selected, setSelected] = useState(new Date());
    const [currentService, setCurrentService] = useState({});

    useEffect(() => {

        const onSuccess = () => {
          SetIsLoading(false)
        }
        if(isAuthentic){
        props.fetchCart(authUser.id)
        }
        setMycart(props.cartArray)
    
      }, []);
    
      useEffect(() => {
       
        //if(isFocused){ 
          if(isAuthentic){
        onDebounceUpdateUserCart(myCart);
        setMycart(myCart)
          }
        //}
      }, [myCart]);
    
    
      const onDebounceUpdateUserCart = useCallback(_.debounce((cart) => {
        const onSuccess = (res) => {
        
        }
      
        props.updateUserCart(authUser.id, {
          cart: cart
        }, onSuccess)
      
      }, 900), []);
    
    
      const onPlus = (serviceID) => {
        if(!isAuthentic){
          history.push('/login')
          return
        }
    
        setMycart(myCart.concat([serviceID]))
    
      };

      
    
      const onMinus = (serviceID) => {
    
        myCart.splice(myCart.findIndex(a => a === serviceID), 1);
    
        setMycart(_.without(myCart, _.find(myCart, serviceID)))
    
      };

    const currentCategoryUpdate = (id) => {
   
      setCurrentCategory(id)
    };

    const currentDepatymentUpdate = (id) => {
    
      setCurrentDepartment(id)
    };

    const keywordToFilter= (id) => {
 
      setKeywordFilter(id)
    };


    useEffect(() => {
    
      setSelectedSlot("")
      setSlots([])
    
      API.doctorbooking().getAvailableTimeSlots({
        doctor: currentService.doctorId,
        bookingDate: new Date(selected).toISOString().split('T')[0] + 'T00:00:00.000+00:00',
      })
        .then(res => {
  
          let booked = res.data
          //console.log('---->1',booked)
          let sl = timeSlots;
          if (new Date(selected).toISOString().split('T')[0] === new Date().toISOString().split('T')[0]) {
  
            sl.filter((ele, index) => {
              sl[index].disabled = false
  
              if (parseInt(ele.value) < parseInt(moment(new Date()).format("HH:mm")) + 0.60) {
                sl[index].disabled = true
              } else {
                if (booked.includes(ele.value)) {
                  sl[index].disabled = true
                }
              }
            })
          } else {
            sl.filter((ele, index) => {
              sl[index].disabled = false
              if (booked.includes(ele.value)) {
                sl[index].disabled = true
              }
            })
          }
  
          console.log(sl)
          setSlots(sl)
        })
        .catch(err => console.log(err))
  
    }, [selected]);

  const confirmBooking = () => {
    API.doctorbooking().create({
      doctor: currentService.doctorId,
      services:[currentService.id],
      type:'treatment',
      customer: authUser.id,
      bookingDate: new Date(selected).toISOString().split('T')[0] + 'T00:00:00.000+00:00',
      bookingTime: selectedSlot,
      status: 'pending',
    })
      .then(res => {
        handleClose()
        Swal.fire({
          title: 'Thank you for booking!',
          text: 'Our customer service agent will call you for appointment confirmation.',
          icon: 'success',
          showConfirmButton: true,

        })

      })
      .catch(err => console.log(err))


  };



  const enableBookAppointmentModal = (service) => {
    if (!isAuthentic) {
      history.push('/login')
      return
    }
    console.log(service)
    setCurrentService(service)

    setSelectedSlot("")
    setSelected(new Date())

    let sl = timeSlots;
    sl.filter((ele, index) => {
      sl[index].disabled = false

      if (parseInt(ele.value) < parseInt(moment(new Date()).format("HH:mm")) + 0.60) {
        sl[index].disabled = true
      }
    })
    setSlots(sl)

    setShow(true);
  }

  const handleClose = () => {
    setShow(false)
    setSelected(new Date())
    setSelectedSlot("")
  };
    return (
        <>
            <section id="shop_main_area" className="pb-5 pt-4">
                <div className="container">
                    <div className="row">
                        {props.location.state.type!=='coupon' && <SideBar title={props.title} currentCategoryUpdate={currentCategoryUpdate} currentDepatymentUpdate={currentDepatymentUpdate} keywordToFilter={keywordToFilter} departments={props.departments} categories={props.categories}/>}
                        <div className={props.location.state.type==='coupon'?"col-lg-12":"col-lg-12"}>
                            <div className="row">
                                {props.services
                                ?.filter(services => currentCategory !== 'all' ? services.categoryId.id == currentCategory : services)
                                ?.filter(services => currentDepartment !== 'all' ? services.department.includes(currentDepartment) : services)
                               // ?.filter(services => currentDepartment !== 'all' ? services.categoryId.id == currentDepartment : services)
                                ?.filter(e => e.title[i18n.language].toLowerCase().includes(keywordFilter.toLowerCase()))
                                ?.map((data, index) => (
                                    <div className={props.location.state.type==='coupon'?"col-lg-6 col-md-6 col-sm-6 col-12":"col-lg-3 col-md-3 col-sm-6 col-12"} key={data.id}>
                                        <ProductCard data={data} 
                    
                      onPlus={() => onPlus(data.id)}
                      onMinus={() => onMinus(data.id)}
                      cartArray={props.cartArray}
                      enableBookAppointmentModal={() => enableBookAppointmentModal(data)}
                      count={_.countBy(myCart)[data.id]}/>
                                    </div>
                                ))}
                                {/* <div className="col-lg-12">
                                    <ul className="pagination">
                                        <li className="page-item" onClick={(e) => { randProduct(page >1?page-1:0) }}>
                                            <a className="page-link" href="#!" aria-label="Previous">
                                                <span aria-hidden="true">«</span>
                                            </a>
                                        </li>
                                        <li className={"page-item "+ (page === 1?"active":null)} onClick={(e) => { randProduct(1) }}><a className="page-link" href="#!">1</a></li>
                                        <li className={"page-item "+ (page === 2?"active":null)}  onClick={(e) => { randProduct(2) }}><a className="page-link" href="#!">2</a></li>
                                        <li className={"page-item "+ (page === 3?"active":null)}  onClick={(e) => { randProduct(3) }}><a className="page-link" href="#!">3</a></li>
                                        <li className="page-item" onClick={(e) => { randProduct(page <3?page+1:0) }}>
                                            <a className="page-link" href="#!" aria-label="Next">
                                                <span aria-hidden="true">»</span>
                                            </a>
                                        </li>
                                    </ul>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>


        <Modal show={show} onHide={handleClose} centered>
          <Modal.Header closeButton>
            <Modal.Title>{t('bookappt')}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className='row'>
              <div className='col-lg-6'>


                <div className="form-group">
                  <label for="exampleInputEmail1">{t('date')}</label>
                  <DatePicker className="btn-block form-control"
                    minDate={new Date()}
                    selected={selected}
                    onChange={(date) => setSelected(date)} />

                </div>
              </div>
              <div className='col-lg-6'>
                <div className="form-group">
                  <label>{t('time')}</label>

                  <select className="form-control" onChange={(e) => setSelectedSlot(e.target.value)}>
                    <option>Choose</option>
                    {slots.map((e, index) => <option key={index} value={e.value} disabled={e.disabled}>{e.name}</option>)}
                  </select>
                </div>
              </div>
              <div className='col-lg-12'>

                <small className="form-text text-muted">Date & time will be confirmed by our customer service agent</small>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            {/* <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button> */}
            <button type="button" className="btn bg-adam" onClick={confirmBooking}>{t('booknow')}</button>
          </Modal.Footer>
        </Modal>
        </>
    )
}


const mapStateToProps = state => ({

    users: state.user.users,
    cart: state.user.cart,
    cartArray: state.user.cartArray
  })
  
  const mapActionToProps = {

    update: actions.update,
    updateUser: user.update,
    updateUserCart: user.updateCart,
    fetchCart: user.fetchCart
  }
  
  export default connect(mapStateToProps, mapActionToProps)(LeftSideBar);